import BANKING from '../../../constants-v2/person/open-banking.js';
import personFullName from '../../../filters/person/person-full-name';
import { moneyFormatToSting } from '../../../helpers/MoneyHelpers';
import { goBackToLastPageIfPagesOverflow } from '../../../helpers/RouteHelpers';
import dateFormat from '../../../procedures/date-format';
import column from '../../abstract/column';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';

export default {
  actions,
  topRightActions: {},
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    type: column({
      label: 'Typ',
      component: 'value-status',
      options: {
        1: { label: 'Przychód', value: Object.keys(BANKING.OPERATION_TYPES)[0], color: '#00ac8b' },
        2: { label: 'Rozchód', value: Object.keys(BANKING.OPERATION_TYPES)[1], color: '#f7b731' },
      },
      format: item => item?.type,
      order: 2
    }),
    amount: column({
      label: 'Kwota', format: item => {
        return `${ moneyFormatToSting(item?.amount) } PLN`;
      },
      order: 4
    }),
    amountToSettle: column({
      label: 'Pozostało do rozliczenia', format: item => {
        return `${ moneyFormatToSting(item?._left_to_settle_amount || 0) } PLN`;
      },
      order:5,
    }),
    bank_name: column({
      label: 'Nazwa banku',
      format: item => item?.bank_account?.label || '-',
      size:100
    }),
    operation_date: column({
      label: 'Data operacji',
      format: item => item?.operation_date,
      order: 6,
      size:100
    }),
    counterparty_name: column({
      label: 'Kontrahent',
      format: item => item?.counterparty_name ?? '-',
      size: 100,
      order: 1
    }),
    description: column({
      label: 'Opis operacji',
      format: item => item?.description || '-',
      size: 100,
    }),
    settlement_status: column({
      label: 'Status rozliczenia',
      component: 'value-status',
      options: BANKING.SETTLEMENT_STATUSES,
      format: item => item?.settlement_status,
      order: 3
    }),
  },
  vars: vars({
    afterItemsSetHook: (
      {
        $route,
        $router,
        paginationData,
        items,
      },
    ) => {
      goBackToLastPageIfPagesOverflow({ $route, $router, paginationData, items });
    },
    noItemsText: ({ $router, $route }) => {
      if ($route?.query?.filters) {
        return 'Brak wyników spełniających kryteria wyszukiwania.';
      }
      return 'Brak operacji bankowych.';
    },
    sidebarLabel: 'Podgląd operacji bankowej',
    softDelete: {
      title: 'Usunięcie operacji bankowej',
      text: (item) => `Czy na pewno chcesz usunąć operację dla ${ personFullName(item?.crm?.person) }?`,
      successText: 'Operacja została usunięta',
    },
    divideFormatter: ({ item: { operation_date } }) => dateFormat(operation_date, 'LLLL yyyy'),
  }),
};
